module.exports = __webpack_public_path__ + "1d9c6d2bdef8a4a69e3f6ae4543c81cf.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/shirt-crab.png
// module id = 1937
// module chunks = 0